/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AdminPanelPageLoader } from './AdminPanelPage/AdminPanelPage.duck';
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as PurchaseAcornsPageLoader } from './PurchaseAcornsPage/PurchaseAcornsPage.duck';
import { loadData as SavedNotesPageLoader } from './SavedNotesPage/SavedNotesPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
// import { loadData as AlgoliaSearchPageLoader } from './AlgoliaSearchPage/AlgoliaSearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as TransactionHistoryPageLoader } from './TransactionHistoryPage/TransactionHistoryPage.duck';
import { loadData as FollowCompanyPageLoader } from './FollowCompanyPage/FollowCompanyPage.duck';

import { loadData as MatchedListingsPageLoader } from './MatchedListingsPage/MatchedListingsPage.duck';

import { loadData as TrackUserPageLoader } from './UserTrack/TrackUserPage.duck';
import { loadData as FractionalBlogPageLoader } from './FractionalBlogPage/FractionalBlogPage.duck';
import { loadData as PostPageLoader } from './PostPage/PostPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AdminPanelPage: {
      loadData: AdminPanelPageLoader,
    },
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    PurchaseAcornsPage: {
      loadData: PurchaseAcornsPageLoader,
    },
    SavedNotesPage: {
      loadData: SavedNotesPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    // AlgoliaSearchPage:{
    //   loadData: AlgoliaSearchPageLoader,
    // },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    MatchedListingsPage: {
      loadData: MatchedListingsPageLoader
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    TransactionHistoryPage: {
      loadData: TransactionHistoryPageLoader
    },
    FollowCompanyPage: {
      loadData: FollowCompanyPageLoader
    },

    TrackUserPage: {
      loadData: TrackUserPageLoader
    },
    FractionalBlogPage: {
      loadData: FractionalBlogPageLoader
    },
    PostPage: {
      loadData: PostPageLoader
    },
  };
};

export default getPageDataLoadingAPI;
